export const QueryKeys = {
  getUsers: ["users"],
} as const;
